import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";
import { cn } from "@/lib/utils";

const skeletonVariants = cva("animate-pulse rounded-md bg-muted", {
  variants: {
    variant: {
      default: "",
      circle: "rounded-full",
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

interface SkeletonProps
  extends
    React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof skeletonVariants> {}

const Skeleton = React.forwardRef<HTMLDivElement, SkeletonProps>(
  ({ className, variant, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(skeletonVariants({ variant, className }))}
        {...props}
      />
    );
  },
);
Skeleton.displayName = "Skeleton";

/**
 * Text-shaped placeholder: sample text drawn transparent on the pulse background, so it takes the
 * line height and wrapping of the text it stands in for and the loaded content keeps its layout.
 */
function SkeletonText({
  children,
  className,
}: {
  children: string;
  className?: string;
}) {
  return (
    <span
      aria-hidden="true"
      className={cn(
        "animate-pulse select-none rounded-sm bg-muted text-transparent [box-decoration-break:clone]",
        className,
      )}
    >
      {children}
    </span>
  );
}

export { Skeleton, SkeletonText };
